import React, { useEffect, useState } from 'react'

import { useConfig } from '../../../contexts/ConfigContext';

import { useTranslation } from "react-i18next";

import { AiFillPlusCircle } from "react-icons/ai";

import { FiArrowLeft, FiArrowRight } from "react-icons/fi"

import { BsTrash } from "react-icons/bs";

import { BiX } from "react-icons/bi";



import { useProduct } from '../../../contexts/ProductContext'

import { useCategory } from '../../../contexts/CategoryContext'

import { useTheme } from '../../../contexts/ThemeContext'

import { useCart } from '../../../contexts/CartContext'

import { FixedHeader, GobackTitle } from '../../Layout/FixedHeader'

import { ProductDetailView } from '../../ProductDetailView';

import { ProductPriceDisplay } from '../../Shared/ProductPrice'

import {

  isProductUnavailable,

  canQuickAdd,

  getListPriceInfo,

  hasRequiredOptions,
  parseVariantIds,
} from '../../../utils/productPricing'



import {

  ProductContainer,

  ProductMain,

  ProductDetail,

  ProductItem,

  ProductCount,

  ProductImgWrapper,

  ProductImg,

  ProductTitle,

  ProductDescription,

  ProductPirceAndCartBtn,

  ProductPrice,

  ClosedMessageBack,

  ClosedMessage,

  CategoryTitle,

} from './styles'



export const Products = (props) => {



  const { catId, handleChangeCat, searchedText, isProductSearched } = props

  const { t } = useTranslation();

  const [theme] = useTheme()

  const currentLng = localStorage.getItem('i18nextLng');

  const [configState] = useConfig()

  const [products, { getVendorProducts }] = useProduct();

  const [categories] = useCategory();

  const [, { addToCart, removeProd, fetchVendorCart, getVendorCartItems }] = useCart();

  const vendorCart = getVendorCartItems(catId);

  const [data, setData] = useState([]);

  const [prodId, setProdId] = useState(null);

  const [loading, setLoading] = useState(false);



  const cat = categories.find(item => item.id === catId);

  const catName = cat ? (currentLng === 'en' ? cat.name_en : cat.name_ar) : '';



  useEffect(() => {

    if (isProductSearched || !catId) return;



    let cancelled = false;

    setLoading(true);

    getVendorProducts(catId).then((vendorProducts) => {

      if (!cancelled) {

        setData(vendorProducts);

        setLoading(false);

      }

    });

    return () => { cancelled = true; };

  }, [catId, isProductSearched, getVendorProducts])



  useEffect(() => {

    if (isProductSearched || !catId) return;

    fetchVendorCart(catId, false);

  }, [catId, isProductSearched, fetchVendorCart])



  useEffect(() => {

    if (!isProductSearched) {

      if (!catId) setData([]);

      return;

    }

    const newArr = products.filter(item =>

      (item.name_en.toLowerCase().search(searchedText) > -1) ||

      (item.name_ar.toLowerCase().search(searchedText) > -1)

    );

    setData(newArr);

  }, [isProductSearched, catId, products, searchedText])



  const getCartCountForProduct = (productId) => {

    return vendorCart

      .filter(obj => obj.prodId === productId)

      .reduce((sum, obj) => sum + obj.count, 0)

  }



  const handleAddToCart = (item) => {

    if (isProductUnavailable(item)) return



    if (hasRequiredOptions(item)) {

      setProdId(item.id)

      return

    }



    const priceInfo = getListPriceInfo(item)

    addToCart(item.id, priceInfo.sellingPrice, { vendorId: catId });

  }



  const handleRemoveCart = (productId) => {
    const line = vendorCart.find(obj => obj.prodId === productId)
    if (line) removeProd(productId, catId, parseVariantIds(line.variant_combination))
  }



  const prodViewHandleClick = (id) => {

    setProdId(id)

  }

  const prodCloseHandleClick = () => {

    setProdId(null)

  }



  if (!isProductSearched && !catId) return null;

  if (loading) return null;



  return (

    data?.length > 0 &&

    <ProductContainer viewType={configState?.configs?.categoryTypeView?configState?.configs?.categoryTypeView:'list'}>

      {!isProductSearched && configState?.configs?.categoryTypeView === 'grid' && (

        <FixedHeader>

          {currentLng === 'en'

            ? <FiArrowLeft size="20" onClick={() => handleChangeCat(null)} />

            : <FiArrowRight size="20" onClick={() => handleChangeCat(null)} />

          }

          <GobackTitle>{catName}</GobackTitle>

        </FixedHeader>

      )}

      {!isProductSearched && configState?.configs?.categoryTypeView === 'list' && (

        <CategoryTitle>{catName}</CategoryTitle>

      )}

      <ProductMain>

        {data.map(item => {

          const unavailable = isProductUnavailable(item)

          const cartCount = getCartCountForProduct(item.id)

          const priceInfo = getListPriceInfo(item)

          const quickAddEnabled = canQuickAdd(item)



          return (

            <ProductItem key={item.id} isAdded={cartCount > 0}>

              <ProductDetail>

                <ProductTitle onClick={() => prodViewHandleClick(item.id)}>

                  {cartCount > 0 && (

                    <ProductCount>

                      {cartCount} <BiX color={theme.colors.primaryIconCol} size="25" />

                    </ProductCount>

                  )}

                  {currentLng === 'en' ? item.name_en : item.name_ar}

                </ProductTitle>

                <ProductDescription>

                  {currentLng === 'en' ? item.description_en : item.description_ar}

                </ProductDescription>

                <ProductPirceAndCartBtn>

                  <ProductPrice unavailable={unavailable}>

                    <ProductPriceDisplay priceInfo={priceInfo} unavailable={unavailable} />

                    <AiFillPlusCircle

                      size="24"

                      color={quickAddEnabled ? theme.colors.primaryIconCol : theme.colors.primaryDisabledCol}

                      onClick={() => {
                        if (unavailable) return
                        quickAddEnabled ? handleAddToCart(item) : prodViewHandleClick(item.id)
                      }}

                    />

                  </ProductPrice>

                  {cartCount > 0 &&

                    <BsTrash color="#b50000" size="22" onClick={() => handleRemoveCart(item.id)} />

                  }

                </ProductPirceAndCartBtn>

              </ProductDetail>

              <ProductImgWrapper>

                <ProductImg src={item.image} alt={item.name_en} onClick={() => prodViewHandleClick(item.id)} />

                {unavailable && (

                  <ClosedMessageBack>

                    <ClosedMessage>{t('Not available')}</ClosedMessage>

                  </ClosedMessageBack>

                )}

              </ProductImgWrapper>

            </ProductItem>

          )

        })}

      </ProductMain>

      {prodId &&

        <ProductDetailView

          prodCloseHandleClick={prodCloseHandleClick}

          prodId={prodId}

          vendorId={catId}

        />

      }

    </ProductContainer>

  )

}

